export default "__VITE_ASSET__fe43b70c__"